import { TIndexableBlock } from "../../../types/general-block-types";
import { ArticleBody } from "../../elements";
import Heading from "../../elements/heading/heading";
import styles from "./article-block.module.less";

export type TArticleBlockProps = {
  heading?: string;
  preamble?: string;
  body?: any;
  sideComponent?: React.ReactNode;
} & TIndexableBlock;

const ArticleBlock = ({ heading, preamble, body, sideComponent, index }: TArticleBlockProps) => {
  return (
    <section className={styles.section}>
      <div className={["padded-sides max-width", styles.innerWrapper].join(" ")}>
        {heading && (
          <Heading
            semanticType={"h2"}
            visualType={"h1"}
            className={[styles.heading, "heading-max-width"].join(" ")}
            index={index}
          >
            {heading}
          </Heading>
        )}
      </div>
      <ArticleBody preamble={preamble} body={body} sideComponent={sideComponent} />
    </section>
  );
};

export default ArticleBlock;
